import { invoke } from '@tauri-apps/api/core';
import type { LicenseEntitlements } from './productMode';

export interface DeviceLicenseRequest {
  format: 'revenue-license-request/v1';
  requestId: string;
  appInstallId: string;
  deviceLockHash: string;
  deviceLabel: string;
  generatedAt: string;
}

export function parseDeviceLicenseRequestContent(content: string): DeviceLicenseRequest {
  let parsed: Partial<DeviceLicenseRequest>;
  try {
    parsed = JSON.parse(content) as Partial<DeviceLicenseRequest>;
  } catch {
    throw new Error('認証リクエストファイルをJSONとして読み込めませんでした');
  }
  if (parsed.format !== 'revenue-license-request/v1') {
    throw new Error('認証リクエストファイルの形式が正しくありません');
  }
  if (!parsed.requestId || !parsed.deviceLockHash || !parsed.appInstallId) {
    throw new Error('認証リクエストファイルに必要な端末情報が含まれていません');
  }
  return {
    format: 'revenue-license-request/v1',
    requestId: parsed.requestId,
    appInstallId: parsed.appInstallId,
    deviceLockHash: parsed.deviceLockHash,
    deviceLabel: parsed.deviceLabel ?? 'Windows PC',
    generatedAt: parsed.generatedAt ?? '',
  };
}

export async function parseDeviceLicenseRequestFile(file: File): Promise<DeviceLicenseRequest> {
  return parseDeviceLicenseRequestContent(await file.text());
}

export async function createDeviceLicenseRequest(): Promise<DeviceLicenseRequest> {
  return await invoke<DeviceLicenseRequest>('create_license_request');
}

export async function saveDeviceLicenseRequestFile(request: DeviceLicenseRequest): Promise<string | null> {
  const defaultFileName = `${request.requestId}.revenue-license-request`;
  return await invoke<string | null>('save_license_request_file', {
    defaultFileName,
    contents: `${JSON.stringify(request, null, 2)}\n`,
  });
}

export function validateLicenseDeviceLock(
  entitlements: LicenseEntitlements,
  currentDeviceLockHash: string,
): void {
  if (!entitlements.deviceLockHash) {
    throw new Error('このライセンスファイルには端末認証情報が含まれていません');
  }
  if (entitlements.deviceLockHash !== currentDeviceLockHash) {
    throw new Error('このライセンスファイルは別のPC向けに発行されています');
  }
}
